import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
import _defineProperty from "C:\\Users\\frontend\\Desktop\\Piaf-Vue 2\\Piaf-Vue\\node_modules\\@babel\\runtime-corejs3/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";

var _require = require("vuelidate/lib/validators"),
    required = _require.required,
    maxLength = _require.maxLength,
    minLength = _require.minLength,
    email = _require.email;

export default {
  data: function data() {
    return {
      form: {
        email: "test@coloredstrategies.com"
      }
    };
  },
  mixins: [validationMixin],
  validations: {
    form: {
      email: {
        required: required,
        email: email,
        minLength: minLength(4)
      }
    }
  },
  computed: _objectSpread({}, mapGetters(["processing", "loginError", "forgotMailSuccess"])),
  methods: _objectSpread({}, mapActions(["forgotPassword"]), {
    formSubmit: function formSubmit() {
      this.$v.form.$touch();

      if (!this.$v.form.$anyError) {
        this.forgotPassword({
          email: this.form.email
        });
      }
    }
  }),
  watch: {
    loginError: function loginError(val) {
      if (val != null) {
        this.$notify("error", "Forgot Password Error", val, {
          duration: 3000,
          permanent: false
        });
      }
    },
    forgotMailSuccess: function forgotMailSuccess(val) {
      if (val) {
        this.$notify("success", "Forgot Password Success", "Please check your email.", {
          duration: 3000,
          permanent: false
        });
      }
    }
  }
};